import React from 'react'
import { useSnackbar } from 'notistack'
import NotificationMessage from './NotificationMessage'

const useNotification = () => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()

    const showNotification = (type, message) => {
        const notificationContent = (key, message) => (
            <NotificationMessage
                type={type}
                onClose={() => closeSnackbar(key)}
                message={message}
            />
        )
        enqueueSnackbar(message, {
            content: notificationContent,
        })
    }

    const showSuccessMessage = (message) => showNotification('success', message)
    const showWarningMessage = (message) => showNotification('warning', message)

    return { showSuccessMessage, showWarningMessage }
}

export default useNotification
